import React from 'react';
import Semibreve from "../assets/semibreve.jsx";
import Minim from "../assets/minim.jsx";
import Crotchet from "../assets/crotchet.jsx";
import Quaver from "../assets/quaver.jsx";
import SemiQuaver from "../assets/semiquaver.jsx";

/**
 * Renders a note timing component based on the provided note value.
 *
 * @param {Object} props - The component props.
 * @param {number} props.noteValue - The value of the note.
 * @returns {JSX.Element} The rendered note timing component.
 */
const ShowNoteTiming = ({ noteValue }) => {
    let noteSvg;


    switch (noteValue) {
        case .25:
            noteSvg = <Semibreve />;
            break;
        case .5:
            noteSvg = <Minim />;
            break;
        case 1:
            noteSvg = <Crotchet />;
            break;
        case 2:
            noteSvg = <Quaver />;
            break;
        case 4:
            noteSvg = <SemiQuaver />;
            break;
        default:
            noteSvg = null;
    }

    return (
        <div style={{ width: '10px', height: '10px' }}>
            {noteSvg}
        </div>
    );
};

export default ShowNoteTiming;
